import type { SupWeb3Address } from "@/types";
import { useMemo } from "react";

import useApi from "@/hooks/api/useApi";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";

export interface ResponseProtocolRewardsClaimable {
  transactionData: SupWeb3Address;
  to: SupWeb3Address;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/30355904-bdf0904f-e565-47af-a9b7-1116333df212?action=share&creator=30355904&ctx=documentation&active-environment=30891008-c5e88594-a241-4ca5-bbab-ec3855318989
 * @param {number} chainId
 */
export default function useClaimProtocolRewards(chainId: number | undefined = undefined) {
  const userAddress = useWeb3UserAddress();

  const enabled = useMemo(() => !!userAddress && !!chainId, [chainId, userAddress]);

  const { data, isLoading, isError, mutate, error } = useApi<ResponseProtocolRewardsClaimable, ResponseProtocolRewardsClaimable>(
    {
      path: `/protocolRewards/claim/${chainId}/${userAddress}/`,
      api: "v2",
    },
    {
      enabled,
      strategy: "fully-cached",
    }
  );

  return {
    data,
    error,
    isLoading,
    isError,
    mutate,
  };
}
